<template>
  <el-dialog :visible.sync="show" :title="name" width="900px">
    <el-form ref="form" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
      <el-form-item prop="topicId" label="专题">
        <el-select v-model="data.topicId" placeholder="选择专题" clearable filterable style="width: 100%">
          <el-option v-for="(item, index) in topicList" :key="index" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <div style="text-align: center">
        <el-button type="primary" style="width: 100%" @click="save" :loading="loading">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      name: '',
      data: {},
      rules: {
        topicId: [{ required: true, trigger: 'change', message: '选择专题' }]
      },
      loading: false,
      type: '',
      topicList: [],
      row: {}
    }
  },
  methods: {
    display(e) {
      this.show = true
      this.data = {}
      this.topicList = []
      this.type = e.type
      this.row = e.row
      this.name = this.ype === 'LaboratoryReport' ? '化验报告专题绑定' : '煤种报价专题绑定'
      const params = {
        conditions: [{ field: 'type', operator: '=', value1: this.type }],
        pageNum: 1,
        pageSize: 1000,
        sorts: []
      }
      this.$axios.post('/paas/sys_shop_special_topic/list', params).then((res) => {
        this.topicList = res.data.data.list
      })
    },

    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            recordId: this.row.id,
            topicId: this.data.topicId
          }
          this.$axios.post('/account/topic/manager/content/addOrUpdate', params).then(() => {
            this.$message.success('绑定成功')
            this.show = false
            this.loading = false
          }).catch(err => {
            console.log('绑定失败', err)
            this.loading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
